import React from 'react';

export const SharedAnalyticsFooter: React.FC = () => {
  return (
    <footer className="border-t border-gray-200 bg-white px-6 py-4 text-center text-sm text-gray-500">
      Powered by Opsero
    </footer>
  );
};

export default SharedAnalyticsFooter;
